module.exports = __webpack_public_path__ + "0b9632854797f9b50a59715fa9e10891.png";